module.exports = __webpack_public_path__ + "img/symbol_2.db36cec8.png";